import { Chip, TableCell, TableRow, Typography } from '@mui/material';
import SvgIconStyle from 'components/SvgIconStyle';
import { useNavigate } from 'react-router';
import { renderRowCreatedAt } from 'utils/renderTableCell';

export const SlidersTableRow = ({ row, index }) => {
  const navigate = useNavigate();
  const { categories, title, tags, createdAt, _id } = row;
  return (
    <>
      <TableRow key={index} hover>
        <TableCell align="left">
          <Typography>{index + 1}</Typography>
        </TableCell>
        <TableCell align="left">
          <Typography>{renderRowCreatedAt('fa-IR', createdAt)}</Typography>
        </TableCell>
        <TableCell align="left">
          <Typography>{title}</Typography>
        </TableCell>
        <TableCell align="left">
          <Typography>{categories[0]?.name || 'تعریف نشده'}</Typography>
        </TableCell>
        <TableCell align="left">
          {tags.map((item, index) => <Chip label={item} key={index} />)}
        </TableCell>
        <TableCell align="left">
          <Typography>فعال</Typography>
        </TableCell>
        <TableCell align="left">
          <div onClick={() => navigate(`/dashboard/slider/detail/${_id}`, { state: row })} aria-hidden>
            <SvgIconStyle src="/icons/send_icon.svg" sx={{ width: 20, height: 20, cursor: 'pointer' }} />
          </div>
        </TableCell>
      </TableRow>
    </>
  );
};
